import axios from "axios"
import {API_PROJECTS} from "../../constants/apiUrls"
import {useTranslation} from "react-i18next"
import LexiconAccordion from "../../components/lexicon-accordion/LexiconAccordion"
import useTeamLexiconId from "../../swrCustomHooks/useTeamLexiconId"
import useProjectLexicon from "../../swrCustomHooks/useProjectLexicon"
import useTeamLexiconItems from "../../swrCustomHooks/useTeamLexiconitems"
import useLexiconItems from "../../swrCustomHooks/useLexiconItems"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import {toast} from "react-toastify"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import isLicenceValidity from "../../tools/isLicenceValidity"

export default function StWorkflowLexicons02({project, setIsPulling}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {teamLexiconId, isLoadingTeamLexiconId, isErrorTeamLexiconId} = useTeamLexiconId(sessionContext.idTeam)
    const {teamLexiconItems, isLoadingTeamLexiconItems, isErrorTeamLexiconItems} = useTeamLexiconItems(typeof teamLexiconId === "object" ? teamLexiconId.team_lexicon.id : teamLexiconId)
    const {projectLexicon, isLoadingProjectLexicon, isErrorProjectLexicon} = useProjectLexicon(sessionContext.idToken, project.id)
    const {lexiconItems, isLoadingLexiconItems, isErrorLexiconItems} = useLexiconItems(projectLexicon?.id)

    const transcription = () => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
            axios.post(`${API_PROJECTS}/${project.id}/tries`, {step: "transcription"}, headersRequest)
            .then((response) => {
                if (response.data.message === `maximun number of tries for "transcription" has been reached or exceeded`) {
                    toast.warning(t("The maximum number of transcriptions has been reached or exceeded!"))
                }
                setIsPulling(true)
            })
            .catch((error) => {
                console.error("POST /projects/project/tries: ", error)
            })
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    if (isErrorTeamLexiconId || isErrorTeamLexiconItems || isErrorProjectLexicon || isErrorLexiconItems ||
        isLoadingTeamLexiconId || isLoadingTeamLexiconItems || isLoadingProjectLexicon || isLoadingLexiconItems ||
        teamLexiconId.message || teamLexiconItems.message || projectLexicon.message || lexiconItems.message
    ) return <LoadingComponent/>
    return (
        <>
        <div className="SECTION ST-WORKFLOW-LEXICON-02">
            <h2>{t("PROJECT LEXICONS")}</h2>
            <div className="lexicons">
                <LexiconAccordion lexiconName={t("Team Lexicon")} lexiconItems={lexiconItems} lexiconID={teamLexiconId} isDisable={true}/>
                <LexiconAccordion lexiconName={projectLexicon.name} lexiconItems={lexiconItems} lexiconID={projectLexicon.id}/>
                {!project.finished && <button className="btn" onClick={transcription} title={t("Transcribe")}>{t("Transcribe")}</button>}
            </div>
        </div>
        </>
    )
}